import 'twin.macro';
import 'styled-components/macro';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { PopperContentProps } from '@radix-ui/react-tooltip';
import { ReactNode } from 'react';

import styles from './styles.module.css';

export interface TooltipProps {
  children?: ReactNode;
  className?: string;
  content?: ReactNode;
  disabled?: boolean;
  placement?: PopperContentProps['side'];
}

export const Tooltip = ({ children, className, content, disabled, placement }: TooltipProps) => {
  if (disabled || !content) {
    return <>{children}</>;
  }

  return (
    <TooltipPrimitive.Provider delayDuration={100}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          {/* See here for why we have the span: https://www.radix-ui.com/docs/primitives/components/tooltip#displaying-a-tooltip-from-a-disabled-button */}
          <span tabIndex={0}>{children}</span>
        </TooltipPrimitive.Trigger>

        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            className={`${styles.tooltipContent} ${className}`}
            side={placement}
            tw="p-1 rounded-lg bg-white text-primary shadow-card text-xs/snug  select-none z-overlay"
          >
            {content}
            {/* a 16x16 square after rotation gives 21x10.5 */}
            <TooltipPrimitive.Arrow tw="[fill: white]" width={21} height={10.5} />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
